module.exports = __webpack_public_path__ + "static/media/notification-white.6bf66a27.svg";